export class RightsMetaData {
    public __classname__: string = 'RightsMetaData';
    
    public CopyrightMarked : boolean | null = null;

	public Copyright: string | null = null;

	public CopyrightURL: string | null = null;

    constructor(
        params : RightsMetaDataNamedParameters
    ) {
        this.CopyrightMarked = params.CopyrightMarked ?? null;
        this.Copyright = params.Copyright ?? null;
        this.CopyrightURL = params.CopyrightURL ?? null;
    }
}

export interface RightsMetaDataNamedParameters{
    CopyrightMarked? : boolean, 
    Copyright?: string, 
    CopyrightURL?: string  
}